<div class="pt-4 flex flex-col gap-4">

  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'waters.information.section.price-introduction' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="!pt-4">
      <app-localized-text-editor
        [nl]="form.controls.priceIntroductionNl"
        [en]="form.controls.priceIntroductionEn"
        [de]="form.controls.priceIntroductionDe"
        [it]="form.controls.priceIntroductionIt"
        [fr]="form.controls.priceIntroductionFr"
      />
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'waters.information.section.plain-price-summary' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="!pt-4">
      <app-localized-text-editor
        [nl]="form.controls.plainPriceSummaryNl"
        [en]="form.controls.plainPriceSummaryEn"
        [de]="form.controls.plainPriceSummaryDe"
        [it]="form.controls.plainPriceSummaryIt"
        [fr]="form.controls.plainPriceSummaryFr"
      />
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'waters.information.section.plain-price-services-text' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="!pt-4">
      <app-localized-text-editor
        [nl]="form.controls.plainPriceServicesTextNl"
        [en]="form.controls.plainPriceServicesTextEn"
        [de]="form.controls.plainPriceServicesTextDe"
        [it]="form.controls.plainPriceServicesTextIt"
        [fr]="form.controls.plainPriceServicesTextFr"
      />
    </mat-card-content>
  </mat-card>

  @for (label of priceLabels(); track $index; let labelIndex = $index) {
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ 'waters.information.price-label' | translate }} {{ $index + 1 }}</mat-card-title>
        <div class="flex-1"></div>
        <button
          mat-icon-button
          type="button"
          color="warn"
          [aria-label]="'generic.remove' | translate"
          [matTooltip]="'generic.remove' | translate"
          (click)="removePriceLabel(labelIndex)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </mat-card-header>
      <mat-card-content class="!pt-4 flex flex-col gap-4">
        <div class="grid grid-cols-1 md:grid-cols-5 gap-2">
          @for (lang of langs; track lang) {
            <mat-form-field>
              <mat-label>{{ ('waters.information.price-label.label' | translate) + ' ' + lang.toUpperCase() }}</mat-label>
              <input
                matInput
                [value]="$any(label)['label' + lang.charAt(0).toUpperCase() + lang.slice(1)] ?? ''"
                (change)="setPriceLabelText(labelIndex, 'label', lang, $any($event.target).value)"
              />
            </mat-form-field>
          }
        </div>
      </mat-card-content>
    </mat-card>
  }
  <button mat-stroked-button type="button" class="self-start" (click)="addPriceLabel()">
    <mat-icon>add</mat-icon>
    {{ 'waters.information.add-price-label' | translate }}
  </button>

</div>
